export default function closest(el, selector) {
    var matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
    while (el) {
        if (matchesSelector.call(el, selector)) {
            return el;
        } else {
            el = el.parentElement;
        }
    }
    return null;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd-mobile/es/_util/closest.js
// module id = null
// module chunks = 